// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1S86M","label":"Labeled_label__3ZyaS","divider":"Labeled_divider__4JlRT"};